<template>
  <div>
    <Rectangle name="资质文件"   />   
    <el-form :model="fileFormModel" :rules="rules" ref="fileForm">
    <el-table :data="tableData" border :span-method="arraySpanMethod">
      <el-table-column
        prop="text"
        label="所需文件">
      </el-table-column>
      <el-table-column
        v-if="!isDetail"
        label="上传">
        <template slot-scope="scope" >
          <el-form-item :prop="scope.row.dataProperty">
            <upload-img
              :name="scope.row.dataProperty"
              class="upload-img"
              :img-id="scope.row.fileId"
              @get-img="getCompanyInfoImg">
            </upload-img>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isDetail"
        label="上传">
          <template slot-scope="scope" >
            <show-img :id="scope.row.fileId" />
          </template>

      </el-table-column>
      <el-table-column
            prop="originFileId"
            width="300"
            label="示例（点击放大）">
            <template slot-scope="scope"  >
              <show-img v-if="scope.row.dataProperty!='authFile'" :src="scope.row.demoFile"/>
              <div v-if="scope.row.dataProperty=='authFile'">
                <el-link class="pdf-link"  :underline="false" title="点击下方链接"></el-link>
                <UcPdfUse :type="pdfInfo.authType" :info="pdfInfo.params" />
              </div>
            </template>
      </el-table-column>
    </el-table>
    </el-form>
  </div>
</template>
<script>
//import ShowImg from "@/views/userManagement/op/components/ShowImg";
//import { saveComInfoChange } from '@/http/usercenter.js';
import UploadImg from '@/components/public/Element/UploadImg.vue';
import { getImageUrl } from "@/http/upload.js";
import IDCard1 from '@/assets/sample-file/ID_card_1.jpg';
import businessLicense from '@/assets/sample-file/business_license.jpg';
import certOfAuth from '@/assets/sample-file/certOfAuth.png';
import ID_card from '@/assets/sample-file/ID_card.jpg';
import allowChangeNoticeIdSample from '@/assets/sample-file/infoChangeAuth.jpg';
import issueAgreementSample from '@/assets/sample-file/issue_agreement.png';
import ShowImg from "@/views/userManagement/op/components/ShowImg";
import UcPdfUse from "@/views/userManagement/components/UcPdfUse"
const authFileList = [
        {text: "授权委托书（盖公章和法人签章）",originFileId:"", fileId:"", dataProperty:"authFile", errorMsg:"请上传授权委托书（盖公章和法人签章）",demoFile: certOfAuth},
        {text: "管理员身份证复印件（盖公章）", originFileId:"", fileId:"", dataProperty:"certFaceId", errorMsg:"请上传管理员身份证复印件（盖公章）", demoFile: IDCard1},
        {text: "营业执照复印件（盖公章）", originFileId:"", fileId:"", dataProperty:"businessLicenceId", errorMsg:"请上传营业执照复印件（盖公章）", demoFile: businessLicense},
        {text: "法人代表身份证复印件（盖公章和法人签章）", originFileId:"", fileId:"", dataProperty:"lawCertFaceId", errorMsg:"请上传法人代表身份证复印件（盖公章和法人签章）", demoFile: ID_card},
        {text: "工商信息变更通知",  originFileId:"", fileId:"", dataProperty:"allowChangeNoticeId", errorMsg:"请上传工商信息变更通知", demoFile: allowChangeNoticeIdSample},
        {text: "签发协议授权流程资质文件",  originFileId:"", fileId:"", dataProperty:"issueAgreement", errorMsg:"签发协议授权流程资质文件", demoFile: issueAgreementSample}
      ];
export default {
  components: { UploadImg, ShowImg, UcPdfUse },
  props:['detail', 'isDetail', 'authFileStatus'],
  data(){
    //console.log('authFileStatus', this.authFileStatus);
    //debugger
    return {
      fileInfo:{},
      rules: {
        authFile: [
          { validator: this.checkUploadFile, trigger:'getImg' }
        ],
        certFaceId: [
          { validator: this.checkUploadFile, trigger:'getImg' }
        ],
        businessLicenceId: [
          { validator: this.checkUploadFile, trigger:'getImg' }
        ],
        lawCertFaceId: [
          { validator: this.checkUploadFile, trigger:'getImg'}
        ],
        allowChangeNoticeId: [
          { validator: this.checkUploadFile, trigger:'getImg'}
        ],
        issueAgreement: [
          { validator: this.checkUploadFile, trigger:'getImg'}
        ]
      }
    }
  },
  methods:{
    arraySpanMethod({ row, column, rowIndex, columnIndex }){
      if(rowIndex==4){
        if(columnIndex==2){
          return [1,2]
        }
      }
    },
    saveFillInfo() {
      this.$emit('saveInfo','fileInfo', this.fileInfo);
    },
    getCompanyInfoImg(fileBase64, fieldId, fileId) {
      // debugger
      this.tableData.forEach((item) => {
          if(item.dataProperty == fieldId) {
            //item.fileId = fileId;
            // debugger
            this.fileInfo[fieldId] = fileId;
            item.fileId = fileId;
            const fileForm = this.$refs['fileForm'];
            if(fileForm) {
              // debugger
              fileForm.validateField(fieldId, error => {
                if(!error) {
                  return true;
                }
                return false;
              });
            }
          }
      });
    },
    getImgUrl(fileId) {
      let url = "static/img/logo.122d232f.png";
      if(fileId) {
        url = getImageUrl(fileId);
      }
      return "";
    },
    checkUploadFile(rule, value, callback) {
      const dataProperty = rule.field;
      // debugger
      if(this.authFileStatus[dataProperty].visible && !this.fileInfo[dataProperty]) {
        return callback(new Error("请上传文件"));
      }
      callback();
    },
    inputValidate() {
      let validatePass = true;
      // debugger
      const fileForm = this.$refs.fileForm;
       if(fileForm) {
         fileForm.validate((valid) => {
           validatePass = valid;
         });
       }
       return validatePass;
    },
  },
  computed: {
    tableData: function() {
      let result = {};
      const _this = this;
      if(!this.isDetail) {
        //debugger
        result =  authFileList.filter((item) => {
            //item.fileId = authFileObj[item.dataProperty].fileId;
            //item.originFileId = authFileObj[item.dataProperty].originFileId;
            //this.fileInfo = this.authFiles;
            /*
            debugger
            if(!_this.authFileStatus[item.dataProperty].visible && _this.fileInfo[item.dataProperty]) {
              delete _this.fileInfo[item.dataProperty];
            }
            */
            
            if(_this.fileInfo[item.dataProperty]) {
              //debugger
              item.fileId = _this.fileInfo[item.dataProperty];
            }
          return _this.authFileStatus[item.dataProperty].visible == true;
        });
      } else {
        result =  authFileList.filter((item) => {
          //debugger
          if(_this.detail.changeto.authFiles[item.dataProperty] && _this.detail.changeto.authFiles[item.dataProperty] != _this.detail.origin.authFiles[item.dataProperty]) {
            //debugger
            item.fileId = _this.fileInfo[item.dataProperty];
            return true;
          }
          return false;
        });
      }
      //debugger
      return result;
    },
    fileFormModel: function() {
      return {
        authFile: this.detail.changeto.authFiles.authFile,
        certFaceId: this.detail.changeto.authFiles.authFile,
        businessLicenceId: this.detail.changeto.authFiles.authFile,
        lawCertFaceId: this.detail.changeto.authFiles.authFile,
        allowChangeNoticeId: this.detail.changeto.authFiles.allowChangeNoticeId,
        issueAgreement: this.detail.changeto.authFiles.issueAgreement
      }
    },
    pdfInfo: function() {
      var userInfoData = this.$parent.$refs['user'].tableData;
      var userName = userInfoData[0].changeto;
      var certNo = userInfoData[2].changeto;
      var currentCompany = JSON.parse(sessionStorage.getItem("company"));
      return {
        authType: currentCompany.companyRole == 'finance' ? 'finance_auth' : 'supplier_auth',
        params: {
          certNo: certNo,
          usrName:  userName
        }
      }
    }
  },
  /*
  computed: {
    tableData: function() {
      debugger
      if(!this.isDetail) {
        return authFileList.filter((item) => {
            //item.fileId = authFileObj[item.dataProperty].fileId;
            //item.originFileId = authFileObj[item.dataProperty].originFileId;
            //this.fileInfo = this.authFiles;
          if(this.authFileStatus[item.dataProperty].visible) {
            item.fileId = authFileObj[item.dataProperty].fileId;
            item.originFileId = authFileObj[item.dataProperty].originFileId;
          }
          return this.authFileStatus[item.dataProperty].visible == true;
        });
      } else {
        return authFileList.filter((item) => {
          if(this.detail.changeto.authFiles[item.dataProperty]) {
            item.fileId = this.detail.changeto.authFiles[item.dataProperty];
            return true;
          }
          return false;
        });
      }
    },
    fileFormModel: function() {
      return {
        authFile: this.detail.changeto.authFiles.authFile,
        certFaceId: this.detail.changeto.authFiles.authFile,
        businessLicenceId: this.detail.changeto.authFiles.authFile,
        lawCertFaceId: this.detail.changeto.authFiles.authFile,
        allowChangeNoticeId: this.detail.changeto.authFiles.allowChangeNoticeId
      }
    }
  },
  */
  created() {
    //debugger
    this.fileInfo = this.detail.changeto.authFiles;
  },
}
</script>

<style lang="less" scoped>
 .tc{
   text-align: center;
 }
 /deep/ .mr10{
   margin-right: 10px;
 }
 .mt50{
   margin-top: 50px;
 }

  /deep/ .error-msg {
   color: red ;
  }
  /deep/ .upload-img {
    width: 72px;
    display: inline-block;
  }
  /deep/ .el-form-item__error {
    display: inline-block;
    position:relative;
    top: 0;
    margin-left: 10px;
  }
  .file-card {
  /deep/ .el-table {
    tbody {
      tr td{
        &:nth-child(2){
          text-align: left !important;
        }
        &:nth-child(1) {
          text-align: right;
        }
      }
    }
  }
}
.display-img {
  width: 72px; height: 72px;margin-top:10px;margin-bottom:10px; float:left
}
.pdf-link {
    background: url("~@/assets/img/pdf.png");
    display: inline-block;
    width: 72px;
    height: 72px;
    background-size: 50%;
    background-repeat: no-repeat;
    background-position: center;
    cursor: default;
  }
</style>